"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKBarChartWidget = void 0;
var react_1 = __importDefault(require("react"));
var components_1 = require("../../components");
var common_1 = require("../../common");
var GKHorizontalBarChart_1 = __importDefault(require("./GKHorizontalBarChart"));
var GKVerticalBarChart_1 = __importDefault(require("./GKVerticalBarChart"));
/**
 * Render a simple bar chart using `div`s (no external libries).
 * At `data.length > 3` it will render vertically, below that, it will render horizontally
 */
var GKBarChartWidget = function (props) {
    var _a = (0, common_1.useMergedProps)(props, {
        _gkComponentIdentifier: "gk-bar-chart-widget",
        className: "w-100 overflow-hidden",
    }), title = _a.title, dropdown = _a.dropdown, data = _a.data, emptyMessage = _a.emptyMessage, mergedProps = __rest(_a, ["title", "dropdown", "data", "emptyMessage"]);
    var qaBase = mergedProps["data-qa"];
    return (react_1.default.createElement("div", __assign({}, mergedProps),
        react_1.default.createElement("div", { className: "d-flex justify-content-between align-items-center mb-4" },
            react_1.default.createElement("span", { "data-qa": qaBase + "--title", className: "text-secondary" }, title),
            dropdown && (react_1.default.createElement(components_1.GKSelect, __assign({ className: "text-nowrap", "data-qa": qaBase + "--dropdown", menuPlacement: "bottom-end" }, dropdown)))),
        data.length === 0 ? (emptyMessage !== null && emptyMessage !== void 0 ? emptyMessage : null) : data.length > 3 ? (react_1.default.createElement(GKHorizontalBarChart_1.default, { data: data, "data-qa": qaBase + "--horizontal-chart" })) : (react_1.default.createElement(GKVerticalBarChart_1.default, { data: data, "data-qa": qaBase + "--vertical-chart", height: 170 }))));
};
exports.GKBarChartWidget = GKBarChartWidget;
exports.default = exports.GKBarChartWidget;
